import React from "react";
import { Button, Dropdown } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

/**
 * 全景类页面：导出 Excel / PDF（截图）
 */
export default function PanoramaExportButtons({ onExportExcel, onExportPdf, disabled }) {
  return (
    <Dropdown
      trigger={["click"]}
      menu={{
        items: [
          {
            key: "excel",
            label: "导出 Excel（当前区间·多 Sheet）",
            onClick: ({ domEvent }) => {
              domEvent?.stopPropagation?.();
              onExportExcel?.();
            },
          },
          {
            key: "pdf",
            label: "导出 PDF（展开全部图表后截图）",
            onClick: ({ domEvent }) => {
              domEvent?.stopPropagation?.();
              onExportPdf?.();
            },
          },
        ],
      }}
    >
      <Button
        type="default"
        icon={<DownloadOutlined />}
        disabled={disabled}
        data-panorama-export-ui
      >
        导出
      </Button>
    </Dropdown>
  );
}
